module.exports = __webpack_public_path__ + "media/images/players/DEFAULT-2245ef73bdca75863ca2a0dd16a2dbd5.png";